/* The listing header's picture slider.
 *
 * Small on purpose. The header is above the fold on every series page, so this
 * runs before anything the customer scrolls to and has no business being large:
 * show one frame, move on click, keep the dots in step.
 *
 * It does not advance on its own. A header that changes while you are reading
 * the three lines beside it is a header arguing with its own page, and the
 * cards below already move on hover -- two things moving at once is a page that
 * will not sit still. The visitor asks; it answers.
 *
 * With the script blocked the markup still renders: the first frame carries
 * `is-on`, the rest sit at zero opacity behind it, and the controls do nothing.
 */
(function () {
  'use strict';

  function kur(slider) {
    var kareler = slider.querySelectorAll('[data-kbw-hero-frame]');
    var noktalar = slider.querySelectorAll('[data-kbw-hero-dot]');
    if (kareler.length < 2) return;

    var simdi = 0;

    function goster(i) {
      // Wraps both ways, so `next` on the last frame returns to the first
      // rather than dead-ending on a button that still looks live.
      simdi = (i + kareler.length) % kareler.length;
      for (var k = 0; k < kareler.length; k++) {
        kareler[k].classList.toggle('is-on', k === simdi);
      }
      for (var n = 0; n < noktalar.length; n++) {
        var acik = n === simdi;
        noktalar[n].classList.toggle('is-on', acik);
        noktalar[n].setAttribute('aria-selected', acik ? 'true' : 'false');
      }
    }

    var onceki = slider.querySelector('[data-kbw-hero-prev]');
    var sonraki = slider.querySelector('[data-kbw-hero-next]');
    if (onceki) onceki.addEventListener('click', function () { goster(simdi - 1); });
    if (sonraki) sonraki.addEventListener('click', function () { goster(simdi + 1); });

    for (var d = 0; d < noktalar.length; d++) {
      (function (i) {
        noktalar[i].addEventListener('click', function () { goster(i); });
      })(d);
    }

    // Arrow keys once something inside has focus, so the slider is reachable
    // without a pointer.
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goster(simdi - 1); }
      else if (e.key === 'ArrowRight') { goster(simdi + 1); }
      else { return; }
      e.preventDefault();
    });
  }

  function baslat() {
    var hepsi = document.querySelectorAll('[data-kbw-hero-slider]');
    for (var i = 0; i < hepsi.length; i++) {
      if (hepsi[i].dataset.kbwHeroReady) continue;
      hepsi[i].dataset.kbwHeroReady = '1';
      kur(hepsi[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
  // The theme editor rebuilds a section without reloading the page.
  document.addEventListener('shopify:section:load', baslat);
})();
